var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" } },
    [
      _c("globalSidebar", { on: { sendTitle: _vm.getTitle } }),
      _c(
        "el-container",
        { staticClass: "is-vertical" },
        [
          _c("globalHeader"),
          _c(
            "el-main",
            { staticStyle: { padding: "0" }, attrs: { id: "main-view" } },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [_c("router-view")],
                1
              ),
            ],
            1
          ),
          _c("globalFooter"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }